//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/tags/views/main/lan/en';
import createEditTag from 'Modules/tags/.components/createEditTag/lan/en';
import deleteTag from 'Modules/tags/.components/deleteTag/lan/en';
import bulkTags from 'Modules/tags/.components/bulkTags/lan/en';



locales = { ...locales, ...main, ...createEditTag, ...deleteTag, ...bulkTags };


export default locales;